module.exports = __webpack_public_path__ + "img/icon-scan-terminal@3x.c8beb146.png";